/** Spanish for the orders area. Keys are the exact English strings the UI renders. */
const orders = {
  'Orders by Date (Excel)': 'Pedidos por fecha (Excel)',
  'Choose dates': 'Elegir fechas',
  'Export orders to Excel': 'Exportar pedidos a Excel',
  'Download all orders you can access, across all statuses, submitted during the selected dates. Both dates are included.': 'Descarga todos los pedidos a los que tienes acceso, de cualquier estado, enviados durante las fechas seleccionadas. Ambas fechas se incluyen.',
  'Custom date range': 'Intervalo de fechas personalizado',
  'All dates': 'Todas las fechas',
  'Start date': 'Fecha inicial',
  'End date': 'Fecha final',
  'End date must be on or after start date.': 'La fecha final debe ser igual o posterior a la fecha inicial.',
  'Downloading...': 'Descargando...',
  'Download Excel': 'Descargar Excel',
  // Orders page header
  'Order Management': 'Gestión de pedidos',
  'Manage orders and track shipments for your practices.':
    'Gestione pedidos y dé seguimiento a los envíos de sus prácticas.',
  'Create and track your orders.': 'Cree y dé seguimiento a sus pedidos.',
  'Search orders...': 'Buscar pedidos...',
  'Export my orders (Excel)': 'Exportar mis pedidos (Excel)',
  'New Order': 'Nuevo pedido',
  'Failed to export orders': 'No se pudieron exportar los pedidos',
  'Could not load orders.': 'No se pudieron cargar los pedidos.',

  // Orders tabs
  'All': 'Todos',
  'Submitted': 'Presentado',
  'Approved': 'Aprobado',
  'Shipped': 'Enviado',
  'Completed': 'Completado',
  'Cancelled': 'Cancelado',

  // Orders table
  'ORDER ID': 'ID DE PEDIDO',
  'PRODUCT': 'PRODUCTO',
  'PRACTICE': 'PRÁCTICA',
  'CUSTOMER PO': 'OC DEL CLIENTE',
  'SUBMITTED BY': 'PRESENTADO POR',
  'QTY': 'CANT.',
  'STATUS': 'ESTADO',
  'DATE': 'FECHA',
  'ACTIONS': 'ACCIONES',
  'No orders found': 'No se encontraron pedidos',
  'N/A': 'N/A',
  'View': 'Ver',
  'View order details': 'Ver detalles del pedido',
  'Delete order {id}': 'Eliminar el pedido {id}',
  'Delete order': 'Eliminar pedido',
  'order {id}': 'el pedido {id}',
  'Showing {first}–{last} of {total}': 'Mostrando {first}–{last} de {total}',
  'Page {page} of {total}': 'Página {page} de {total}',
  'Previous': 'Anterior',
  'Next': 'Siguiente',
  // Submitter role suffix (utils/submitterName.js): "Name (clinic)" / "Name (admin)"
  'clinic': 'clínica',
  'admin': 'administrador',

  // Order details modal
  'Order Details': 'Detalles del pedido',
  'Order Date': 'Fecha del pedido',
  'Delivery Date': 'Fecha de entrega',
  'Not set': 'Sin definir',
  'Clinic': 'Clínica',
  'Customer PO': 'OC del cliente',
  'Delivery Address': 'Dirección de entrega',
  'Select state': 'Seleccione un estado',
  'Your saved delivery address. You can edit it for this order.': 'Su dirección de entrega guardada. Puede editarla para este pedido.',
  'Address changes apply to this order only.': 'Los cambios de dirección se aplican solo a este pedido.',
  'Products': 'Productos',
  'Qty:': 'Cant.:',
  'Remove item': 'Quitar artículo',
  'Ordered Qty: {n}': 'Cant. pedida: {n}',
  'Shipped Qty: {n}': 'Cant. enviada: {n}',
  'Add Product': 'Agregar producto',
  'Select a product...': 'Seleccione un producto...',
  'Add': 'Agregar',
  '{name} is already on this order. Change its quantity instead.':
    '{name} ya está en este pedido. En su lugar, cambie la cantidad.',
  'Tracking Number': 'Número de seguimiento',
  'Other': 'Otro',
  'Sales Representative': 'Representante de ventas',
  'Note from Customer': 'Nota del cliente',
  'Note from MedEffects': 'Nota de MedEffects',
  'Add a note...': 'Agregue una nota...',
  'Cancel Order': 'Cancelar pedido',
  'Approve': 'Aprobar',
  'Enter tracking number...': 'Ingrese el número de seguimiento...',
  'Ship': 'Enviar',
  'Please enter a tracking number': 'Ingrese un número de seguimiento',
  'Action failed': 'La acción no se pudo completar',
  // Server sentences an admin can hit from the details modal (orders.service.ts)
  'Order not found': 'Pedido no encontrado',
  'Tracking number is required when shipping an order':
    'Se requiere un número de seguimiento para enviar un pedido',
  'A shipped quantity referenced a line item that is not on this order. Refresh and try again.':
    'Una cantidad enviada hace referencia a una línea que no está en este pedido. Actualice e inténtelo de nuevo.',
  'The same line item was given a shipped quantity twice.':
    'A la misma línea se le asignó una cantidad enviada dos veces.',

  // New order modal
  'Shipping option': 'Opción de envío',
  'Preferred shipper': 'Transportista preferido',
  'Close': 'Cerrar',
  'Could not load clinics. Close and reopen to retry - submission is blocked until the clinic list loads.':
    'No se pudieron cargar las clínicas. Cierre y vuelva a abrir para reintentar; el envío está bloqueado hasta que se cargue la lista de clínicas.',
  'No clinics are assigned to you. Contact an administrator before submitting.':
    'No tiene clínicas asignadas. Contacte a un administrador antes de enviar.',
  'Select clinic...': 'Seleccione una clínica...',
  'No products are available to order.': 'No hay productos disponibles para pedir.',
  'Could not load products. Reload the page, or contact an administrator.':
    'No se pudieron cargar los productos. Recargue la página o comuníquese con un administrador.',
  'Could not load the product sizes. Reload the page, or contact an administrator.':
    'No se pudieron cargar los tamaños de los productos. Recargue la página o comuníquese con un administrador.',
  '+ Add Product': '+ Agregar producto',
  'Product {n}': 'Producto {n}',
  'Quantity {n}': 'Cantidad {n}',
  'Remove product {n}': 'Quitar el producto {n}',
  'Select product...': 'Seleccione un producto...',
  'This product does not state its size in its name, so it cannot be ordered here. Tell MedEffects.':
    'Este producto no indica su tamaño en el nombre, por lo que no se puede pedir aquí. Avise a MedEffects.',
  'Street address': 'Dirección (calle y número)',
  'Comment': 'Comentario',
  'Notes for this order...': 'Notas para este pedido...',
  'Cancel': 'Cancelar',
  'Creating...': 'Creando...',
  'Create Order': 'Crear pedido',
  'Failed to create order': 'No se pudo crear el pedido',
  // Server sentences on create (orders.service.ts)
  'A clinic is required. Select the clinic this order is for.':
    'Se requiere una clínica. Seleccione la clínica a la que corresponde este pedido.',
  'At least one product is required. Provide either lineItems or product with quantity.':
    'Se requiere al menos un producto. Indique lineItems o un producto con su cantidad.',

  // Shipments page
  'Shipment Tracking': 'Seguimiento de envíos',
  'Monitor shipments and manage tracking information. Shipments are auto-created when orders are approved & shipped.':
    'Supervise los envíos y administre la información de seguimiento. Los envíos se crean automáticamente cuando los pedidos se aprueban y se envían.',
  'Search shipments...': 'Buscar envíos...',
  'TRACKING ID': 'N.º DE SEGUIMIENTO',
  'No shipments found': 'No se encontraron envíos',
  'Pending': 'Pendiente',
  'In Transit': 'En tránsito',
  'Change Status': 'Cambiar estado',
  'Copy tracking ID': 'Copiar número de seguimiento',
  'Delete shipment for order {id}': 'Eliminar el envío del pedido {id}',
  'Delete shipment': 'Eliminar envío',
  'shipment for order {id}': 'el envío del pedido {id}',
  'Failed to update status': 'No se pudo actualizar el estado',
  'Shipment statuses match their orders and update automatically.': 'Los estados de los env\u00edos coinciden con sus pedidos y se actualizan autom\u00e1ticamente.',
  'Status unavailable': 'Estado no disponible',
  'Could not refresh shipments. Statuses may be out of date.': 'No se pudieron actualizar los env\u00edos. Los estados pueden estar desactualizados.',
  'Could not refresh orders. Statuses may be out of date.': 'No se pudieron actualizar los pedidos. Los estados pueden estar desactualizados.',
  'Shipments unavailable.': 'Env\u00edos no disponibles.',
  'Could not confirm completion. Refresh shipments before trying again.': 'No se pudo confirmar la finalizaci\u00f3n. Actualice los env\u00edos antes de volver a intentarlo.',
  'Shipment not found': 'Envío no encontrado',
  "Choose a shipping service": "Elija un servicio de env\u00edo",
  "Choose a shipping service to calculate the estimated delivery date automatically. Orders at or after 4 PM Mountain Time move to the next shipping day. Shipping and delivery are Monday through Friday. Delivery times are not guaranteed.": "Elija un servicio de env\u00edo para calcular la fecha estimada de entrega autom\u00e1ticamente. Los pedidos recibidos a partir de las 4 p. m., hora de la monta\u00f1a, pasan al siguiente d\u00eda de env\u00edo. Los env\u00edos y las entregas son de lunes a viernes. Los horarios de entrega no est\u00e1n garantizados.",
  "Checking delivery availability...": "Consultando la disponibilidad de entrega...",
  "The requested date was moved to the next available weekday. Review the updated delivery date.": "La fecha solicitada se cambi\u00f3 al siguiente d\u00eda disponible de lunes a viernes. Revise la fecha de entrega actualizada.",
  "Shipping availability changed. Review the updated delivery date, then select Create Order again.": "La disponibilidad de env\u00edo cambi\u00f3. Revise la fecha actualizada y seleccione Crear pedido de nuevo.",
  "Could not confirm shipping availability. Please try again before placing the order.": "No se pudo confirmar la disponibilidad de env\u00edo. Int\u00e9ntelo de nuevo antes de crear el pedido.",
  "Check delivery again": "Consultar la entrega de nuevo",
  "Estimated Delivery Date": "Fecha estimada de entrega",
  "Calculated automatically": "Se calcula autom\u00e1ticamente",
  "Shipping information": "Informaci\u00f3n de env\u00edo",
  "Delivery city": "Ciudad de entrega",
  "Delivery state": "Estado de entrega",
  "Delivery ZIP code": "C\u00f3digo postal de entrega",
  "ZIP code": "C\u00f3digo postal",
  "Use default address": "Usar direcci\u00f3n predeterminada",
  // Shipping documents and administrator intake review.
  "Shipping documents": "Documentos de env\u00edo",
  "Shipping documents for order {id}": "Documentos de env\u00edo del pedido {id}",
  "Refresh documents": "Actualizar documentos",
  "Loading shipping documents...": "Cargando documentos de env\u00edo...",
  "No shipping documents are available yet.": "A\u00fan no hay documentos de env\u00edo disponibles.",
  "Shipping slip {n}": "Comprobante de env\u00edo {n}",
  "Download shipping slip {n}": "Descargar comprobante de env\u00edo {n}",
  "Download PDF": "Descargar PDF",
  "Preparing PDF...": "Preparando PDF...",
  "Preparing shipping document...": "Preparando documento de env\u00edo...",
  "This shipping document is unavailable. Refresh and try again.": "Este documento de env\u00edo no est\u00e1 disponible. Actualice e int\u00e9ntelo de nuevo.",
  "This shipping document is too large to download. Contact MedEffects for help.": "Este documento de env\u00edo es demasiado grande para descargar. Contacte a MedEffects para obtener ayuda.",
  "This shipping document changed. Refresh and review it again.": "Este documento de env\u00edo cambi\u00f3. Actualice y rev\u00edselo de nuevo.",
  "Could not download the shipping document. Please try again.": "No se pudo descargar el documento de env\u00edo. Int\u00e9ntelo de nuevo.",
  "Could not load shipping documents. Please try again.": "No se pudieron cargar los documentos de env\u00edo. Int\u00e9ntelo de nuevo.",
  "Tracking reviews": "Revisiones de seguimiento",
  "Document reviews": "Revisiones de documentos",
  "Review every page before sharing a shipping slip. Documents stay private until approved for one order and shipment.": "Revise todas las p\u00e1ginas antes de compartir un comprobante. Los documentos permanecen privados hasta que se aprueban para un pedido y env\u00edo.",
  "Refresh reviews": "Actualizar revisiones",
  "Could not load document reviews. Please try again.": "No se pudieron cargar las revisiones de documentos. Int\u00e9ntelo de nuevo.",
  "Loading document reviews...": "Cargando revisiones de documentos...",
  "No shipping documents need review.": "No hay documentos de env\u00edo pendientes de revisi\u00f3n.",
  "Review document": "Revisar documento",
  "First page": "Primera p\u00e1gina",
  "Back to reviews": "Volver a revisiones",
  "Download PDF for review": "Descargar PDF para revisar",
  "Order number": "N\u00famero de pedido",
  "Find shipments": "Buscar env\u00edos",
  "Could not find shipments for that order. Check the order number and try again.": "No se pudieron encontrar env\u00edos para ese pedido. Verifique el n\u00famero de pedido e int\u00e9ntelo de nuevo.",
  "No eligible shipments match that order number.": "No hay env\u00edos elegibles que coincidan con ese n\u00famero de pedido.",
  "Shipment for this document": "Env\u00edo de este documento",
  "Choose a shipment...": "Seleccione un env\u00edo...",
  "I reviewed every page. This PDF contains only the selected order and belongs to this shipment.": "Revis\u00e9 todas las p\u00e1ginas. Este PDF contiene \u00fanicamente el pedido seleccionado y corresponde a este env\u00edo.",
  "Approve document": "Aprobar documento",
  "Reject document": "Rechazar documento",
  "Updating document review...": "Actualizando revisi\u00f3n del documento...",
  "Could not confirm the document review. Refresh before trying again.": "No se pudo confirmar la revisi\u00f3n del documento. Actualice antes de volver a intentarlo.",
  "Verify the order and shipment before applying a tracking notice. Dismiss notices that no longer need action.": "Verifique el pedido y el env\u00edo antes de aplicar un aviso de seguimiento. Descarte los avisos que ya no necesitan atenci\u00f3n.",
  "Could not load tracking reviews. Please try again.": "No se pudieron cargar las revisiones de seguimiento. Int\u00e9ntelo de nuevo.",
  "Loading tracking reviews...": "Cargando revisiones de seguimiento...",
  "No tracking notices need review.": "No hay avisos de seguimiento pendientes de revisi\u00f3n.",
  "Tracking unavailable": "Seguimiento no disponible",
  "Already recorded on a shipment": "Ya registrado en un env\u00edo",
  "Review tracking": "Revisar seguimiento",
  "Possible orders: {orders}": "Posibles pedidos: {orders}",
  "I verified this tracking notice belongs to the entered order.": "Verifiqu\u00e9 que este aviso de seguimiento corresponde al pedido ingresado.",
  "Confirm delivery": "Confirmar entrega",
  "Apply tracking": "Aplicar seguimiento",
  "Dismiss review": "Descartar revisi\u00f3n",
  "Updating tracking review...": "Actualizando revisi\u00f3n de seguimiento...",
  "This tracking review changed. Refresh and review it again.": "Esta revisi\u00f3n de seguimiento cambi\u00f3. Actualice y rev\u00edsela de nuevo.",
  "Could not confirm the tracking review. Refresh before trying again.": "No se pudo confirmar la revisi\u00f3n de seguimiento. Actualice antes de volver a intentarlo.",
  "Multiple orders match": "Varios pedidos coinciden",
  "PO differs": "La orden de compra es diferente",
  "No unique sent-order match": "No se encontr\u00f3 un \u00fanico pedido enviado que coincida",
  "Delivery association needs verification": "La asociaci\u00f3n de entrega necesita verificaci\u00f3n",
  "Notification requires verification": "El aviso necesita verificaci\u00f3n",
  "Document status": "Estado del documento",
  "Carrier": "Transportista",
  "Choose carrier": "Elija un transportista",
  "Other / Not sure": "Otro / No estoy seguro",
  "Choose a carrier before shipping this order.": "Elija un transportista antes de enviar este pedido.",
  "Check the FedEx tracking number against the shipping notice.": "Verifique el n\u00famero de seguimiento de FedEx en el aviso de env\u00edo.",
  "Check the UPS tracking number against the shipping notice.": "Verifique el n\u00famero de seguimiento de UPS en el aviso de env\u00edo.",
  "Enter a valid tracking number.": "Ingrese un n\u00famero de seguimiento v\u00e1lido.",
  "Could not ship this order. Please try again.": "No se pudo enviar este pedido. Int\u00e9ntelo de nuevo.",
  "Needs review": "Necesita revisi\u00f3n",
  "Approved documents may need another review after shipping records change.": "Los documentos aprobados pueden necesitar otra revisi\u00f3n si cambian los registros de env\u00edo.",
  "No shipping documents found.": "No se encontraron documentos de env\u00edo.",
  "Rejected documents cannot be shared.": "Los documentos rechazados no se pueden compartir.",
  "Tracking review status": "Estado de la revisi\u00f3n de seguimiento",
  "Shadow matches": "Coincidencias de prueba",
  "Shadow matches have not changed any orders. Applying one will update the selected order.": "Las coincidencias de prueba no han cambiado ning\u00fan pedido. Al aplicar una se actualizar\u00e1 el pedido seleccionado.",
};

export default orders;
